import React from 'react';
import { LogIn } from 'lucide-react';

const AdminLogin = () => {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-stone-900 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">⚡</span>
          </div>
          <h1 className="text-2xl font-bold text-stone-900">@techbaenae Admin</h1>
          <p className="text-stone-500 mt-2">Sign in to manage your website</p>
        </div>
        
        <button
          onClick={handleLogin}
          className="w-full bg-stone-900 text-white py-3 px-6 rounded-xl font-medium flex items-center justify-center gap-2 hover:bg-stone-800 transition-colors"
        >
          <LogIn className="w-5 h-5" />
          Sign in with Google
        </button>
        
        <p className="text-xs text-stone-400 mt-4">
          Only authorized admins can access this area
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
